export default "__VITE_ASSET__C78C0O2w__"